import * as React from 'react'
import { sendAmplitudeEvent, AmplitudeEvents } from '@repo/analytics/amplitude/utils'

export const useAmplitudeProductListViewed = ({
  category,
  subCategory,
  categoryId,
}: {
  category: string
  subCategory?: string
  categoryId?: string
}) => {
  React.useEffect(() => {
    if (category) {
      const eventData: Record<string, unknown> = {
        category: category,
        subcategory: subCategory,
        view: 'main',
      }

      if (categoryId) {
        eventData.category_ID = categoryId
      }

      sendAmplitudeEvent(AmplitudeEvents.PRODUCT_LIST_VIEWED, eventData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
